module.exports = __webpack_public_path__ + "img/IMG_2024_L.ccf382d9.webp";